import { eAtlas, Game } from "../../Game";
import { AtlasUtils } from "../../Utils/Atlas/AtlasUtils";
import { Gameplay, TIMER } from "../Gameplay";
import { Shooter } from "../Player/Shooter";
import { RoundManager } from "../Round/RoundManager";
import { ManCityIntro } from "./ManCityIntro";

const enum eCharCardState {
    off,
    slideIn,
    delayBeforeSlideOut,
    slideOut
}


export class CharCard {
    private static readonly WIDTH = 196;
    private static readonly HEIGHT = 196;

    private static readonly EDGE_OFFSET = 20;
    private _verEdgeOffset: number;

    /**
     * Entita zobrazujici kartu na screen
     */
    private _entity: pc.Entity;

    private _state: eCharCardState;
    private _stateTime: number;
    private _stateUpdateFncs: (() => void)[];

    private _charId: number;
    private _charCardRc = new pc.Vec4();

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        let atlas = Game.getAtlas(eAtlas.def1);

        this._verEdgeOffset = pc.platform.ios ? CharCard.EDGE_OFFSET : 80;

        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: CharCard.WIDTH,
            height: CharCard.HEIGHT,
            anchor: [1, 0, 1, 0],
            pivot: [0, 0],
        });
        this._entity.enabled = false;
        screen.addChild(this._entity);

        // Update funkce pro jednotlive stavy
        this._stateUpdateFncs = [];
        this._stateUpdateFncs[eCharCardState.slideIn] = this.updateSlideIn;
        this._stateUpdateFncs[eCharCardState.delayBeforeSlideOut] = this.updateDelayBeforeSlideOut;
        this._stateUpdateFncs[eCharCardState.slideOut] = this.updateSlideOut;

        // Zachytavat zahajeni kola hry
        Gameplay.instance.events.once(ManCityIntro.EVENT_COMPLETE, (): void => {
            Gameplay.instance.events.on(RoundManager.EVENT_ROUND_READY, this.handleRoundReady, this);
            this.handleRoundReady();
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._charId = -1;
        this._entity.enabled = false;
        this._state = eCharCardState.off;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._state == eCharCardState.off)
            return;

        this._stateUpdateFncs[this._state].call(this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleRoundReady(): void {
        if (this._charId != Shooter.instance.charId) {
            this._charId = Shooter.instance.charId;

            // Zahajit zobrazeni karty
            let rc = AtlasUtils.getAtlasFrameRegion(Game.getAtlas(eAtlas.def1), "charCards/" + this._charId, this._charCardRc);

            this._entity.element.rect = rc;
            this._entity.enabled = true;

            this._state = eCharCardState.slideIn;
            this._stateTime = TIMER.time;

            this.update();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateSlideIn(): void {
        let progress = (TIMER.time - this._stateTime) / 500;

        if (progress >= 1) {
            progress = 1;
            this._state = eCharCardState.delayBeforeSlideOut;
            this._stateTime = TIMER.time;
        }

        progress = pc.CubicOut(progress);

        this._entity.setLocalPosition(-(CharCard.WIDTH + CharCard.EDGE_OFFSET) * progress, this._verEdgeOffset, 0);
        this._entity.element.opacity = progress;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateDelayBeforeSlideOut(): void {
        if (TIMER.time - this._stateTime > 2000) {
            this._state = eCharCardState.slideOut;
            this._stateTime = TIMER.time;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateSlideOut(): void {
        let progress = (TIMER.time - this._stateTime) / 500;

        if (progress >= 1) {
            this._state = eCharCardState.off;
            this._entity.enabled = false;
        }

        progress = pc.CubicIn(progress);

        this._entity.setLocalPosition(-(CharCard.WIDTH + CharCard.EDGE_OFFSET) * (1 - progress), this._verEdgeOffset, 0);
        this._entity.element.opacity = 1 - progress;
    }
}